import script from "./detailMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./detailMaterial.vue?vue&type=script&setup=true&lang=js"

import "./detailMaterial.vue?vue&type=style&index=0&id=eecb351c&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eecb351c"]])

export default __exports__